module.exports = __webpack_public_path__ + "static/media/Portrait-10270.f91ef91d.jpg";